import { gql } from '@apollo/client';
import { ITimeosUser, IUser } from '@dokucoach/common-types';

export interface User extends IUser {
  id?: string;
  rights?: string[];
  nursingHome: {
    id: string;
    name: string;
    license: {
      invoicingEnabledFrom: Date | null;
    };
  };
}

export interface TimeosConfig {
  timeosUser?: ITimeosUser;
  timeosCustomerId?: string;
}

export interface GetUserByToken extends TimeosConfig {
  getUserByToken?: User;
}

export const GET_USER_BY_TOKEN = gql`
  query getUserByToken($token: String!) {
    getUserByToken(token: $token) {
      id
      name {
        firstFull
        firstCall
        last
        title
        gender
      }
      username
      nursingHome {
        id
        name
        license {
          invoicingEnabledFrom
        }
      }
      rights
    }
    timeosUser {
      id
      username
      isSynchronized
    }
    timeosCustomerId
  }
`;

export const REFRESH_TOKEN = gql`
  mutation refreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      accessToken
      tokenType
      expiresIn
      refreshToken
    }
  }
`;

export const TODAYS_USERS = gql`
  query todaysUsers($clientInput: ClientInput!) {
    todaysUsers(clientInput: $clientInput) {
      id
      name {
        firstFull
        last
        gender
      }
      username
    }
  }
`;

const TOKEN_QUERY = `
  accessToken
  tokenType
  expiresIn
  refreshToken
  isFirstLogin
`;

export const PASSWORD_LOGIN = gql`
  mutation passwordLogin($data: PasswordTokenRequestInput!) {
    passwordLogin(data: $data) {
      ${TOKEN_QUERY}
    }
  }
`;

export const INITIAL_LOGIN = gql`
  mutation initialLogin($data: InitialTokenRequestInput!) {
    initialLogin(data: $data) {
      token {
        ${TOKEN_QUERY}
      }
      client {
        clientId
        secret
      }
    }
  }
`;

export const PIN_LOGIN = gql`
  mutation pinLogin($data: PinTokenRequestInput!) {
    pinLogin(data: $data) {
      ${TOKEN_QUERY}
    }
  }
`;

export const LOGOUT = gql`
  mutation logout {
    logout {
      success
    }
  }
`;
